<template lang='pug'>
v-container(fluid class="pa-0")
  v-app-bar(app, flat, dense, fixed, dark, color='primary')
    v-app-bar-nav-icon(@click='toggleDrawerMenu')
    v-toolbar-title(class='subtitle-1') エクスポート
  v-container(fluid)
    v-row(align='center', justify='center')
      v-card(min-width="220", flat, class="timecell ml-2", width='220')
        v-menu(v-model='monthmenu', :close-on-content-click='false',transition='scale-transition', offset-y)
          template(v-slot:activator="{ on }")
            .subtitle タイムカード
            v-text-field(v-model='targetMonth', label='対象月', v-on="on", dense, readonly, class="timeinput", width='220', class="centered-input")
          v-date-picker(v-model='targetMonth', no-title, type="month", @change='monthmenu = false')
        v-btn(color="primary", :disabled="targetMonth == null", @click='downloadExcel') エクセルダウンロード
      v-card(min-width="220", flat, class="timecell ml-2", width='220')
        v-menu(v-model='monthmenu2', :close-on-content-click='false',transition='scale-transition', offset-y)
          template(v-slot:activator="{ on }")
            .subtitle 有給データ
            v-text-field(v-model='targetMonth2', label='対象月', v-on="on", dense, readonly, class="timeinput", width='220', class="centered-input")
          v-date-picker(v-model='targetMonth2', no-title, type="month", @change='monthmenu2 = false')
        v-btn(color="primary", :disabled="targetMonth2 == null", @click='downloadVacationExcel') エクセルダウンロード
  v-overlay(:value='progressOverlay')
    v-progress-circular(indeterminate, size='64')
</template>

<script>
import basic from '@/components/mixins/basic'

export default {
  mixins: [basic],
  components: {
  },
  computed: {
    monthText() {
      if (this.targetMonth == null) { return '' }
      return ''
    }
  },
  data() {
    return {
      monthmenu: false,
      targetMonth: null,
      monthmenu2: false,
      targetMonth2: null,
      progressOverlay: false
    }
  },
  mounted() {
  },
  methods: {
    async masterReady () {
      if (!this.$store.getters['Login/isAdmin']) {
        // redirect to home when you are not admin
        this.$router.push(this.site.deployFolder + "/")
      }
      await this.search()
    },
    async search () {
      this.users = await this.$store.dispatch("Users/getUsers");
    },
    async downloadExcel () {
      this.progressOverlay = true
      try {
        await this.$store.dispatch("ExcelDownload/download", this.targetMonth)
      } catch (e){
        // eslint-disable-next-line no-console
        console.error(e)
      }
      this.progressOverlay = false
    },
    async downloadVacationExcel () {
      this.progressOverlay = true
      try {
        await this.$store.dispatch("ExcelDownload/downloadVacation", this.targetMonth2)
      } catch (e){
        // eslint-disable-next-line no-console
        console.error(e)
      }
      this.progressOverlay = false
    },
    toggleDrawerMenu () {
      this.$emit('toggle')
    }
  }
};
</script>

<style scoped lang='scss'>

</style>